import { render, staticRenderFns } from "./BulkDownloadDialog.vue?vue&type=template&id=20dbedca"
import script from "./BulkDownloadDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./BulkDownloadDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports